import React from "react";
import { Pressable, View } from "react-native";
import { Text } from "@louise/ui/Text/Text";
import { LinearGradient } from "expo-linear-gradient";
import {
  pressLabel,
  usePressCapture,
} from "@src/packages/analytics/usePressCapture";

type FilterChipProps = {
  label: string;
  isSelected: boolean;
  onPress: () => void;
  showGreenDot?: boolean;
};

export function FilterChip({
  label,
  isSelected,
  onPress,
  showGreenDot = false,
}: FilterChipProps) {
  const capturePress = usePressCapture("FilterChip");
  return (
    <Pressable
      onPress={() => {
        capturePress(pressLabel(label), "filter_chip");
        onPress();
      }}
    >
      {({ pressed }) => (
        <View
          className={`flex-row items-center gap-2 rounded-full border px-3 py-2 ${
            isSelected ? "" : "border-white/8"
          } ${pressed ? "opacity-80" : ""}`}
          style={
            isSelected
              ? {
                  borderColor: "rgba(129, 140, 248, 0.4)",
                  shadowColor: "rgba(99, 102, 241, 0.1)",
                  shadowOffset: { width: 0, height: 0 },
                  shadowOpacity: 1,
                  shadowRadius: 20,
                  elevation: 0,
                  overflow: "hidden",
                }
              : {
                  backgroundColor: "rgba(255, 255, 255, 0.02)",
                  borderColor: "rgba(255, 255, 255, 0.08)",
                }
          }
        >
          {isSelected && (
            <>
              <LinearGradient
                colors={["rgba(99, 102, 241, 0.15)", "rgba(79, 70, 229, 0.05)"]}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 1 }}
                style={{
                  position: "absolute",
                  left: 0,
                  right: 0,
                  top: 0,
                  bottom: 0,
                }}
              />
              <View
                style={{
                  position: "absolute",
                  left: 0,
                  right: 0,
                  top: 0,
                  height: 1,
                  backgroundColor: "rgba(255, 255, 255, 0.05)",
                }}
              />
            </>
          )}
          {showGreenDot && isSelected && (
            <View
              className="h-1.5 w-1.5 rounded-full bg-emerald-400"
              style={{
                shadowColor: "rgba(52, 211, 153, 0.6)",
                shadowOffset: { width: 0, height: 0 },
                shadowOpacity: 1,
                shadowRadius: 8,
                elevation: 0,
              }}
            />
          )}
          <Text
            variant="body"
            size="sm"
            className={`text-xs ${
              isSelected ? "font-medium text-[#E0E7FF]" : "text-slate-400"
            }`}
            style={
              isSelected
                ? {
                    textShadowColor: "rgba(99, 102, 241, 0.4)",
                    textShadowOffset: { width: 0, height: 0 },
                    textShadowRadius: 12,
                  }
                : {}
            }
          >
            {label}
          </Text>
        </View>
      )}
    </Pressable>
  );
}
